import { SvgIcon, SvgIconProps } from '@material-ui/core';

/**
 * Should be the same as the VOC Now logo.
 * @see https://github.com/project44/portal-v2-ui/blob/1dc78d7d958fa3efa951acb414fdd65480743cbd/src/components/common/assets/logo.svg
 */
const P44Logo = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 662.82 226.54">
      <g>
        <g>
          <path
            fill="#2d2a26"
            d="M35,64.79h8q20.91,0,20.92,20.46v71.51Q63.92,177,43,177H35q-11.26,0-14.26-9v40.7H0V64.79H20.69v9Q23.69,64.79,35,64.79Zm8.28,88.75V88.24q0-4.14-1.38-5.4t-5.52-1.26h-8q-4.14,0-5.87,1.83c-1.14,1.23-1.72,3.3-1.72,6.21v62.54c0,2.91.58,5,1.72,6.21s3.11,1.84,5.87,1.84h8q4.14,0,5.52-1.26C42.77,158.11,43.23,156.3,43.23,153.54Z"
          />
          <path
            fill="#2d2a26"
            d="M112.43,64.56H117V82.5h-8.28q-14.48,0-14.48,17V177H73.57V64.79h20.7v13.8a20.93,20.93,0,0,1,6.55-10A17.22,17.22,0,0,1,112.43,64.56Z"
          />
          <path
            fill="#2d2a26"
            d="M146,64.79h24.6Q192,64.79,192,85.25v71.51Q192,177,170.6,177H146q-21.15,0-21.15-20.24V85.25Q124.85,64.79,146,64.79Zm25.52,89V88q0-4.14-1.38-5.51t-5.52-1.38H152q-4.14,0-5.4,1.38T145.31,88v65.76q0,4.14,1.27,5.52t5.4,1.38h12.64q4.14,0,5.52-1.38T171.52,153.77Z"
          />
          <path
            fill="#2d2a26"
            d="M202.57,185.74V64.79h20.68v123.7q0,20.23-21.38,20.24H191.52V192.41h4.14q4.14,0,5.52-1.4C202.1,190.1,202.57,188.33,202.57,185.74ZM202.1,43.41V22.94h21.61V43.41Z"
          />
          <path
            fill="#2d2a26"
            d="M255.21,64.79h22.54q21.6,0,21.61,20.46v42.08h-45.3V154c0,2.62.46,4.37,1.38,5.29s2.76,1.38,5.52,1.38h10.58q4.14,0,5.52-1.38t1.38-5.52v-9.19h20.23v12.18q0,20.24-21.38,20.24H255.21q-21.37,0-21.38-20.24V85.25Q233.83,64.79,255.21,64.79Zm-1.15,47.37H278.9V87.78c0-2.6-.43-4.37-1.27-5.28s-2.64-1.38-5.4-1.38H261q-4.14,0-5.52,1.38c-.92.91-1.38,2.68-1.38,5.28Z"
          />
          <path
            fill="#2d2a26"
            d="M374.77,100.2H354.31v-12q0-4.14-1.38-5.4t-5.52-1.26h-9.89c-2.76,0-4.59.42-5.51,1.26s-1.39,2.64-1.39,5.4v65.3c0,2.76.47,4.57,1.39,5.41s2.75,1.26,5.51,1.26h9.89q4.14,0,5.52-1.26c.92-.84,1.38-2.65,1.38-5.41V141.59h20.46v15.17q0,20.24-21.61,20.24H331.31q-21.37,0-21.38-20.24V85.25q0-20.46,21.38-20.46h21.85q21.6,0,21.61,20.46Z"
          />
          <path
            fill="#2d2a26"
            d="M430.34,81.58H414.93v71c0,2.76.43,4.57,1.27,5.41s2.64,1.26,5.4,1.26h8.74V177H415.63Q394,177,394,156.76V81.58H383.43V64.79H394V45.71h20.92V64.79h15.41Z"
          />
          <path fill="#ffffff" d="M560.87,113.7l1.36-1.36h0l-1.35,1.36Z" />
          <path
            fill="#236092"
            d="M469.42,193.42a113.42,113.42,0,0,0,159.17,1c.35-.34.71-.67,1-1a113.31,113.31,0,0,0,0-160.23h0A113.3,113.3,0,0,0,469.4,193.42h0"
          />
          <polygon
            fill="#ffffff"
            points="531.83 94.38 511.28 94.38 511.28 125.6 481.04 125.6 512.27 45.59 491.25 45.59 460.71 125.34 460.71 144.86 511.28 144.86 511.28 177.11 531.83 177.11 531.83 144.86 545.06 144.86 545.06 125.6 531.83 125.6 531.83 94.38"
          />
          <polygon
            fill="#ffffff"
            points="623.15 94.38 602.59 94.38 602.59 125.6 572.35 125.6 603.6 45.59 582.58 45.59 552.05 125.34 552.05 144.86 602.59 144.86 602.59 177.11 623.15 177.11 623.15 144.86 636.39 144.86 636.39 125.6 623.15 125.6 623.15 94.38"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default P44Logo;
